import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EducationsByEducationTypeComponent } from './educations-by-education-type/educations-by-education-type.component';

const routes: Routes = [
  { path: ':lang/:educationtype/:id', pathMatch: 'full', component: EducationsByEducationTypeComponent, runGuardsAndResolvers: 'always' },
  /*{ path: ':lang/:koulutustyyppi/:organisaatioyksikko/:educationtype/:id', pathMatch: 'full', component: EducationsByEducationTypeComponent }*/
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EducationRoutingModule { }
